import { render, staticRenderFns } from "./NewsTab.vue?vue&type=template&id=197c2b5c&"
import script from "./NewsTab.vue?vue&type=script&lang=ts&"
export * from "./NewsTab.vue?vue&type=script&lang=ts&"
import style0 from "./NewsTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports